import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


function DialogImportSpreadsheet({ open, onCancel, onSave }) {
  const [sheetLink, setSheetLink] = React.useState("");
  function handleChange(event) {
    setSheetLink(event.target.value);
  }

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Import Google Sheet</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Google Sheets Link:
        </DialogContentText>
        <TextField
          autoComplete="off"
          autoFocus
          margin="dense"
          id="sheetsLink"
          label="Sheets Link"
          type="text"
          value={sheetLink}
          onChange={handleChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel();
            setSheetLink("");
          }}
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSave(sheetLink);
            setSheetLink("");
          }}
          color="primary"
        >
          Import
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default DialogImportSpreadsheet;
